export default {
  styleOverrides: {
    root: {
      borderRadius: '8px',
      fontWeight: 500,
      transition: 'background-color 0.2s ease',
    },

    filled: {
      backgroundColor: 'color-mix(in srgb, var(--color-text) 10%, transparent)',
      color: 'var(--color-text)',

      '&:hover': {
        backgroundColor: 'color-mix(in srgb, var(--color-text) 20%, transparent)',
      },
    },

    outlined: {
      borderColor: 'var(--color-text)',
      color: 'var(--color-text)',

      '&:hover': {
        backgroundColor: 'color-mix(in srgb, var(--color-text) 20%, transparent)',
      },
    },

    filledPrimary: {
      backgroundColor: 'color-mix(in srgb, var(--color-primary) 10%, transparent)',
      color: 'var(--color-primary)',

      '&:hover': {
        backgroundColor: 'color-mix(in srgb, var(--color-primary) 20%, transparent)',
      },
    },

    outlinedPrimary: {
      borderColor: 'var(--color-primary)',
      color: 'var(--color-primary)',

      '&:hover': {
        backgroundColor: 'color-mix(in srgb, var(--color-primary) 20%, transparent)',
      },
    },

    filledError: {
      backgroundColor: 'color-mix(in srgb, var(--color-error) 10%, transparent)',
      color: 'var(--color-error)',

      '&:hover': {
        backgroundColor: 'color-mix(in srgb, var(--color-error) 20%, transparent)',
      },
    },

    outlinedError: {
      borderColor: 'var(--color-error)',
      color: 'var(--color-error)',

      '&:hover': {
        backgroundColor: 'color-mix(in srgb, var(--color-error) 20%, transparent)',
      },
    },

    filledWarning: {
      backgroundColor: 'color-mix(in srgb, var(--color-warning) 10%, transparent)',
      color: 'var(--color-warning)',

      '&:hover': {
        backgroundColor: 'color-mix(in srgb, var(--color-warning) 20%, transparent)',
      },
    },

    outlinedWarning: {
      borderColor: 'var(--color-warning)',
      color: 'var(--color-warning)',

      '&:hover': {
        backgroundColor: 'color-mix(in srgb, var(--color-warning) 20%, transparent)',
      },
    },

    filledSecondary: {
      backgroundColor: 'color-mix(in srgb, var(--color-text-secondary) 10%, transparent)',
      color: 'var(--color-text-secondary)',

      '&:hover': {
        backgroundColor: 'color-mix(in srgb, var(--color-text-secondary) 20%, transparent)',
      },
    },

    deleteIcon: {
      color: 'inherit',
      opacity: 0.7,

      '&:hover': {
        color: 'inherit',
        opacity: 1,
      },
    },

    icon: {
      color: 'inherit',
    },
  },
};
